unit View.Cidade.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils;

type
  TFViewCidadeList = class(TForm)
    btNew: TButton;
    CidadeDataset: TXDataWebDataSet;
    CidadeDatasetID: TIntegerField;
    CidadeDatasetNome: TStringField;
    CidadeDatasetCodigoIBGE: TIntegerField;
    CidadeDatasetDistrito: TBooleanField;
    CidadeDatasetUF_Id: TIntegerField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCidadeList: TFViewCidadeList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCidadeList }

procedure TFViewCidadeList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCidadeList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCidadeList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCidadeList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCidadeList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCidadeList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewCidadeList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewCidadeList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCidadeList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      CidadeDataset.Connection.Model.DefaultSchema.FindEntityType(CidadeDataset.EntitySetName),
      CidadeDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCidadeList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('cidade', 'active');
  TUtils.SetValorDicionarioClasses('localidades_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_localidades', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    CidadeDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCidadeList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cidade.list.pagination.info');
  btNew := TButton.Create('view.cidade.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.cidade.list.table');
  cbPageSize := TComboBox.Create('view.cidade.list.cbPageSize');
  edSearch := TEdit.Create('view.cidade.list.search');
  lcPaginator := TListControl.Create('view.cidade.list.pagination');
  CidadeDataset := TXDataWebDataSet.Create(Self);
  CidadeDatasetID := TIntegerField.Create(Self);
  CidadeDatasetNome := TStringField.Create(Self);
  CidadeDatasetCodigoIBGE := TIntegerField.Create(Self);
  CidadeDatasetDistrito := TBooleanField.Create(Self);
  CidadeDatasetUF_Id := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  CidadeDataset.BeforeLoadDFMValues;
  CidadeDatasetID.BeforeLoadDFMValues;
  CidadeDatasetNome.BeforeLoadDFMValues;
  CidadeDatasetCodigoIBGE.BeforeLoadDFMValues;
  CidadeDatasetDistrito.BeforeLoadDFMValues;
  CidadeDatasetUF_Id.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewCidadeList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ID';
      Title := 'ID';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Nome';
      Title := 'Nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'CodigoIBGE';
      Title := 'CodigoIBGE';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Distrito';
      Title := 'Distrito';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'UF_Id';
      Title := 'UF_Id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    CidadeDataset.SetParentComponent(Self);
    CidadeDataset.Name := 'CidadeDataset';
    CidadeDataset.EntitySetName := 'Cidade';
    CidadeDataset.Connection := DMConnection.ApiConnection;
    CidadeDataset.Left := 72;
    CidadeDataset.Top := 144;
    CidadeDatasetID.SetParentComponent(CidadeDataset);
    CidadeDatasetID.Name := 'CidadeDatasetID';
    CidadeDatasetID.FieldName := 'ID';
    CidadeDatasetID.Required := True;
    CidadeDatasetNome.SetParentComponent(CidadeDataset);
    CidadeDatasetNome.Name := 'CidadeDatasetNome';
    CidadeDatasetNome.FieldName := 'Nome';
    CidadeDatasetNome.Required := True;
    CidadeDatasetNome.Size := 255;
    CidadeDatasetCodigoIBGE.SetParentComponent(CidadeDataset);
    CidadeDatasetCodigoIBGE.Name := 'CidadeDatasetCodigoIBGE';
    CidadeDatasetCodigoIBGE.FieldName := 'CodigoIBGE';
    CidadeDatasetCodigoIBGE.Required := True;
    CidadeDatasetDistrito.SetParentComponent(CidadeDataset);
    CidadeDatasetDistrito.Name := 'CidadeDatasetDistrito';
    CidadeDatasetDistrito.FieldName := 'Distrito';
    CidadeDatasetDistrito.Required := True;
    CidadeDatasetUF_Id.SetParentComponent(CidadeDataset);
    CidadeDatasetUF_Id.Name := 'CidadeDatasetUF_Id';
    CidadeDatasetUF_Id.FieldName := 'UF_Id';
    CidadeDatasetUF_Id.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := CidadeDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    CidadeDataset.AfterLoadDFMValues;
    CidadeDatasetID.AfterLoadDFMValues;
    CidadeDatasetNome.AfterLoadDFMValues;
    CidadeDatasetCodigoIBGE.AfterLoadDFMValues;
    CidadeDatasetDistrito.AfterLoadDFMValues;
    CidadeDatasetUF_Id.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
